<div class="agpr-dateDisplay">
    <div
        [ngStyle]="{
            'text-align': data.styles.font.alignment,
            'background-color': data.styles.backgroundColor,
            'font-weight': data.styles.font.bold ? 'bold' : 'normal',
            'color': data.styles.font.color,
            'font-family': data.styles.font.fontFamily,
            'font-size': data.styles.font.fontSize,
            'font-style': data.styles.font.italics ? 'italic' : 'normal',
            'text-decoration': data.styles.font.underlined ? 'underline' : 'none',
            'display': 'block',
            'line-height': '100%',
            'padding-top': data.styles.padding.paddingOption
                ? (data.styles.padding.topPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
            'padding-right': data.styles.padding.paddingOption
                ? (data.styles.padding.rightPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
            'padding-bottom': data.styles.padding.paddingOption
                ? (data.styles.padding.bottomPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
            'padding-left': data.styles.padding.paddingOption
                ? (data.styles.padding.leftPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px'
        }"
    >
        @if (showRecurrencePlaceholder) {
            {{ recurrencePlaceholder }}
        } @else if (dateRange) {
            {{ dateRange.start | agprDateString: effectiveFormat : timezone : data.styles.locale }}
            &ndash;
            {{ dateRange.end | agprDateString: effectiveFormat : timezone : data.styles.locale }}
        } @else if (singleDate !== null) {
            {{ singleDate | agprDateString: effectiveFormat : timezone : data.styles.locale }}
        } @else {
            {{ data.date | agprDateString: effectiveFormat : timezone : data.styles.locale }}
        }
    </div>
</div>